import { Component, Input, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';

import { BaseFormList, MessageService } from '../../../../../../core';

import { NgForm } from '@angular/forms';

@Component({
    selector: 'sgt-campanha-item-form',
    templateUrl: './campanha-item-form.component.html',
    styleUrls: ['./campanha-item-form.component.less']
})
export class CampanhaItemFormComponent {
    @Input() canEdit = true;

    @ViewChild('form') form: NgForm;

    constructor(private messageService: MessageService) { }

    /** Verifica se os itenss da campanha estão válidos */
    isValid(): boolean {
        // Form válido
        // if (this.form.invalid) {
        //     this.messageService.warning('Informe corretamente todos os campos da promoção de itens desta campanha', 'Atenção');
        //     return false;
        // }

        return true;
    }

    /** Resolve os itens presentes na campanha */
    resolve() { }
}
